import React from 'react'
import { MainLinkButton } from '../styled/buttons/MainLinkButton'

export const StaticAdContainer: React.FC<any> = () => {
  const buttonHref = '/pricing'
  const buttonText = 'Get started now'
  return (
    <section className="relative h-[260px] lg:h-[360px] max-w-[1396px] mx-auto overflow-hidden">

      <div className="absolute inset-0 bg-gradient-to-r from-[#0B1113] via-[#0B1113] via-40% to-transparent z-10"></div>
      
      <div 
        className="absolute top-0 right-0 h-full w-2/3"
        style={{
          backgroundImage: `url(/img/subscribeAd.jpeg)`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      ></div>
      
      <div className="relative z-20 flex flex-col justify-center items-center lg:items-start gap-5 h-full px-4 lg:px-14">
        <div className='uppercase font-bold text-[16px] text-center lg:text-left lg:text-[36px] eurostile md:w-3/4 lg:max-w-[700px] text-white lg:leading-[44px]'>
          get access to over 11,000 2D & 3D VFX assets by subscribing today!
        </div>
        <MainLinkButton 
          href={buttonHref}
          variant='blue' 
          className='!bg-[#00A1E0] !text-[14px] lg:!text-[17px] hover:!bg-a-light-blue !text-white !w-[200px] lg:!w-[258px] !h-[40px] lg:!h-[56px]'
        >
          {buttonText}
        </MainLinkButton>
      </div>
    </section>
  )
}